/**
 * Smart API base URL helper.
 *
 * Returns the configured backend URL (from build-time env) ONLY when it
 * matches the page's current hostname. Otherwise falls back to an empty
 * string so all `${API_BASE}/api/...` calls become same-origin relative
 * paths — which Cloudflare/Ingress will route to the correct backend pod.
 *
 * Why this exists:
 *   In CRA, REACT_APP_* env vars are baked into the JS bundle at build time.
 *   If the deploy pipeline serves an old bundle pointing to a now-deleted
 *   debug subdomain, every API call breaks. With this helper, the app
 *   silently recovers by using relative URLs.
 *
 * Usage:
 *   import { API_BASE } from '@/utils/apiBase';
 *   fetch(`${API_BASE}/api/foo`)
 */

const computeBase = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (!envUrl) return '';
  if (typeof window === 'undefined') return envUrl;
  try {
    const envHost = new URL(envUrl).hostname;
    const currentHost = window.location.hostname;
    // Same host -> use env URL. Different host (and we're not on localhost dev) -> use relative.
    if (envHost !== currentHost && currentHost !== 'localhost') {
      return '';
    }
  } catch {
    // URL parse failed; trust env value
  }
  return envUrl;
};

export const API_BASE = computeBase();

export default API_BASE;
